<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 lg8>
          <v-flex xs12 mb-3 v-bind:class="{ 'mr-3': large }">
            <h1 class="max">{{i18n('Configurações da API')}}</h1>
          </v-flex>
          <v-flex xs12 v-bind:class="{ 'mb-3': small, 'mr-3': large }">
            <APIConfig />
          </v-flex>
        </v-flex>
        <v-flex xs12 lg4>
          <v-flex xs12 mb-3 v-bind:class="{ 'mr-3': large }">
            <h1 class="max">{{i18n('Gerenciar Feriados Bacen')}}</h1>
          </v-flex>
          <v-flex xs12 v-bind:class="{ 'mb-3': small, 'mr-3': large }">
            <HolidaysList />
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>

import LeftBarLayout from "../layouts/LeftBarLayout"
import HolidaysList from "../components/HolidaysList"
import APIConfig from "../components/APIConfigFields.vue"

export default {
  name: 'ConfigPage',
  components: {
    layout: LeftBarLayout,
    APIConfig,
    HolidaysList
  },
  computed: {
    large() {
      return ['lg','xl'].includes(this.$vuetify.breakpoint.name)
    },
    small() {
      return ['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name)
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    let has_registered_company = this.$cookies.isKey('company_id') && this.$cookies.get('company_id') !== ''
    if (!has_registered_company) {
      this.$router.push('/')
      return
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ConfigPage.vue